export default __webpack_public_path__ + "static/media/ClassicVideo02.eeeddb62.mp4";